<template>
  <div>
    <Load v-if="isLoading" />
    <template v-if="!isLoading && campaignStatus === 'active'">
      <div class="full-page">
        <PDPProductFamilies
          v-if="!isBnn"
          :products="productFamilies"
          :isFromQRCode="isFromQRCode"
          :select="selectLevel1Code"
          @click="onClickLevel1"
        />

        <v-container>
          <div
            :class="['product-detail-layout', { '-is-bnn': isBnn }]"
          >
            <PDPProductName
              :campaignName="modelName"
              :sku="sku"
              class="dp-block dp-md-none"
            />

            <div
              :class="[
                'pdp-preview-swiper',
                {
                  gallery: isBnn,
                },
              ]"
            >
              <template v-if="thumbnailList.length > 0">
                <template v-if="isBnn">
                  <PreviewImageSwiper
                    loop
                    showThumbnail
                    allowTouchMove
                    :medias="thumbnailList"
                    :key="keyPreview"
                  />
                </template>
                <PDPGallery v-else :media="thumbnailList" />
              </template>
            </div>

            <div
              class="pdp-content"
              :class="{ 'select-by-sku': isFromQRCode }"
            >
              <div class="pdp-content-container">
                <template v-if="isVip">
                  <div>
                    <h3 class="hurry-up-label body-s">
                      <template v-if="isBnn">
                        <span class="font-bold">
                          สิ้นสุดเวลาลงทะเบียนความสนใจ
                          {{ expiredAt }}
                        </span>
                      </template>
                      <template v-else>
                        <span class="badge-pre-order">
                          ลงทะเบียนความสนใจ
                        </span>
                        สิ้นสุดใน
                      </template>
                    </h3>
                    <div class="mt-4">
                      <CountDown
                        v-if="timeLeft > -1"
                        v-bind="{
                          size: 'md',
                          justify: 'flex-start',
                        }"
                        :timeLeft="timeLeft"
                        :isDefault="false"
                        :isColon="false"
                        :isStudio7="!isBnn"
                        isPDP
                        @end="reload"
                      />
                    </div>
                  </div>

                  <hr v-if="isBnn" class="divider-gray-83 m-0" />

                  <PDPProductName
                    :campaignName="modelName"
                    :sku="sku"
                    class="dp-none dp-md-block"
                  />

                  <PDPPricing
                    @openPaymentMethod="handleOpenPaymentMethod"
                  />

                  <BaseProductSeriesConfigurations
                    v-if="isBnn"
                    :items="productFamilies"
                    :selected="selectLevel1Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Series"
                    key-title="name"
                    key-selected="code"
                    key-image="main_image"
                    key-price="min_price"
                    @change="onClickLevel1"
                  />

                  <BaseProductColorConfigurations
                    :items="p_level2"
                    :selected="selectLevel2Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Color"
                    key-title="name"
                    key-selected="code"
                    @change="onClickLevel2"
                  />

                  <BaseProductConfigurations
                    :items="p_level3"
                    :selected="selectLevel3Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Model"
                    key-title="name"
                    key-selected="code"
                    @change="onClickLevel3"
                  />

                  <BaseProductConfigurations
                    :items="p_level4"
                    :selected="sku"
                    :isFromQRCode="isFromQRCode"
                    headline="Capacity"
                    key-title="size"
                    key-selected="sku"
                    @change="onClickLevel4"
                  />

                  <template v-if="isBnn">
                    <div v-if="!isFromStockCard">
                      <v-btn
                        :ripple="false"
                        plain
                        color="#eba614"
                        width="fit-content"
                        height="fit-content"
                        class="btn-link promotion-privileges"
                        @click="handleOpenPromotionPrivileges"
                      >
                        <v-icon>
                          mdi-tag-outline
                        </v-icon>
                        ดูรายละเอียดโปรโมชั่นและสิทธิพิเศษเพิ่มเติม
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </v-btn>
                    </div>

                    <div
                      v-if="previewHtml"
                      v-html="previewHtml"
                      class="preview-html"
                    ></div>
                  </template>
                </template>
                <template v-else>
                  <div>
                    <h3 class="hurry-up-label body-s">
                      <template v-if="isBnn">
                        <span class="font-bold">
                          สิ้นสุดเวลาสั่งซื้อ/จองล่วงหน้า
                          {{ expiredAt }}
                        </span>
                      </template>
                      <template v-else>
                        <span class="badge-pre-order">
                          สั่งซื้อล่วงหน้า!
                        </span>
                        เริ่ม {{ startDate }}
                      </template>
                    </h3>
                    <div class="mt-4">
                      <CountDown
                        v-if="timeLeft > -1"
                        v-bind="{
                          size: 'md',
                          justify: 'flex-start',
                        }"
                        :timeLeft="timeLeft"
                        :isDefault="false"
                        :isColon="false"
                        :isStudio7="!isBnn"
                        isPDP
                        @end="reload"
                      />
                    </div>
                  </div>

                  <hr v-if="isBnn" class="divider-gray-83 m-0" />

                  <PDPProductName
                    :campaignName="modelName"
                    :sku="sku"
                    class="dp-none dp-md-block"
                  />

                  <PDPPricing
                    @openPaymentMethod="handleOpenPaymentMethod"
                  />

                  <LabelProduct
                    v-if="isBnn && isShowLabelFreebie"
                    labelType="free"
                    title="รับฟรีของแถม"
                    remark="ขอสงวนสิทธิ์ในการเปลี่ยนแปลงของแถมโดยไม่ต้องแจ้งให้ทราบล่วงหน้า"
                    :data="freebieItems"
                    showMore
                  />

                  <div v-if="!isFromStockCard && !isBnn" class="mb-4">
                    <v-btn
                      :ripple="false"
                      plain
                      color="#bf4800"
                      width="fit-content"
                      height="fit-content"
                      class="btn-link promotion-privileges"
                      @click="handleOpenPromotionPrivileges"
                    >
                      <v-icon>
                        mdi-tag-outline
                      </v-icon>
                      ดูรายละเอียดโปรโมชั่นและสิทธิพิเศษเพิ่มเติม
                      <v-icon>
                        mdi-chevron-right
                      </v-icon>
                    </v-btn>
                  </div>

                  <BaseProductSeriesConfigurations
                    v-if="isBnn"
                    :items="productFamilies"
                    :selected="selectLevel1Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Series"
                    key-title="name"
                    key-selected="code"
                    key-image="main_image"
                    key-price="min_price"
                    @change="onClickLevel1"
                  />

                  <BaseProductColorConfigurations
                    :items="p_level2"
                    :selected="selectLevel2Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Color"
                    key-title="name"
                    key-selected="code"
                    @change="onClickLevel2"
                  />

                  <BaseProductConfigurations
                    :items="p_level3"
                    :selected="selectLevel3Code"
                    :isFromQRCode="isFromQRCode"
                    headline="Model"
                    key-title="name"
                    key-selected="code"
                    @change="onClickLevel3"
                  />

                  <BaseProductConfigurations
                    :items="p_level4"
                    :selected="sku"
                    :isFromQRCode="isFromQRCode"
                    headline="Capacity"
                    key-title="size"
                    key-selected="sku"
                    @change="onClickLevel4"
                  />

                  <template v-if="isShowWarrantyProduct">
                    <AppleCareSwiper
                      v-if="hasMultipleWarranties"
                      :key="`applecare-${sku}`"
                      :data="activeWarranties"
                      @change="checkSummary"
                    />
                    <AppleCare v-else @change="checkSummary" />
                  </template>

                  <template v-if="isBnn">
                    <div v-if="!isFromStockCard">
                      <v-btn
                        :ripple="false"
                        plain
                        color="#eba614"
                        width="fit-content"
                        height="fit-content"
                        class="btn-link promotion-privileges"
                        @click="handleOpenPromotionPrivileges"
                      >
                        <v-icon>
                          mdi-tag-outline
                        </v-icon>
                        ดูรายละเอียดโปรโมชั่นและสิทธิพิเศษเพิ่มเติม
                        <v-icon>
                          mdi-chevron-right
                        </v-icon>
                      </v-btn>
                    </div>

                    <div
                      v-if="previewHtml"
                      v-html="previewHtml"
                      class="preview-html"
                    ></div>
                  </template>

                  <PDPQuantity />

                  <hr v-if="isBnn" class="divider-gray-83 m-0" />

                  <template v-if="!isBnn">
                    <div>
                      <div class="title-medium mb-4">
                        Get it fast
                      </div>
                      <PDPShipping />
                    </div>

                    <PDPAccordion :items="pdpInfoAccordion" />
                  </template>

                  <!-- Bundle -->
                  <div
                    v-if="
                      isBnn && isShowSwiperBundle && !isFromStockCard
                    "
                  >
                    <div class="mb-4">
                      <span class="text-label">คู่กันคุ้มกว่า</span>
                      <span v-if="bundleList" class="font-bold">
                        : {{ bundleList }}
                      </span>
                    </div>
                    <template v-if="bundlesItemsNoFreebie">
                      <BundleSwiper
                        :data="bundlesItemsNoFreebie"
                        key="bundle"
                        @select="onClickSelectBundle"
                      />
                    </template>
                  </div>
                  <!-- End Bundle -->
                </template>
              </div>

              <!-- ShipDate -->
              <div ref="cartShip"></div>
            </div>
          </div>
          <!-- End Content -->

          <template v-if="isBnn">
            <TabsProduct
              :tab-content="isTabContent"
              :tab-compare="isTabCompare"
            >
              <template v-if="isTabContent" v-slot:content>
                <div
                  v-html="footerHtml"
                  class="html-content mt-4"
                ></div>
              </template>
              <template v-if="isTabCompare" v-slot:compare>
                <div
                  v-html="compareHtml"
                  class="html-content mt-4"
                ></div>
              </template>
            </TabsProduct>
          </template>

          <template v-else>
            <PDPRiverContent
              v-if="!isVip"
              :title="`${modelName}`"
              :isHasCompare="isTabCompare"
              :isHasLearnMore="isTabContent"
              @learnMore="handleOpenLearnMore"
              @compare="handleOpenCompare"
            />

            <PDPAccordion
              :items="pdpOverviewAccordion"
              isOverview
              flat
              expandedDefault
            />

            <PDPProductAlsoBought
              v-if="isShowSwiperBundle && !isFromStockCard"
              title="ซื้อรวมกันบ่อย"
              isBundle
              keyProducts="bundle"
              :items="bundlesItemsNoFreebie"
              @toggle="checkSummary"
            />
          </template>

          <!-- Display when additionalProduct is available and not from stock card -->
          <template v-if="hasAdditionalProduct && !isFromStockCard">
            <PDPProductAlsoBought
              v-for="(item, index) in additionalProduct"
              :key="index"
              :keyProducts="`additional-${index}`"
              :title="item.group"
              :items="item.products"
              isBundle
              @toggle="checkSummary"
            />
          </template>

          <!-- Modals -->
          <PDPModalLearnMore
            v-if="isTabContent"
            ref="PDPModalLearnMore"
            :htmlContent="footerHtml"
          />

          <PDPModalCompare
            v-if="isTabCompare"
            ref="PDPModalCompare"
            :htmlContent="compareHtml"
          />

          <PDPModalPaymentMethod ref="PDPModalPaymentMethod" />

          <PDPModalPromotionPrivileges
            ref="PDPModalPromotionPrivileges"
          />

          <ModalSevenClubMember ref="sevenClubMemberModal" />
          <!-- End Modal -->
        </v-container>

        <PDPStickyCTA
          ref="PDPStickyCTA"
          data-pptr="PDPStickyCTA"
          :is-sold-out="isSoldOut"
          @openPaymentMethod="handleOpenPaymentMethod"
        >
          <template v-slot:cta>
            <div class="wrap-btn-action">
              <!-- ? New: GP-230 [NPI] Display only one button for both deposit and full payment, with the user selecting the payment type (deposit or full) on the checkout page instead of the PDP -->
              <div class="btn-action-item full">
                <div class="wrap-btn-action-case">
                  <v-btn
                    color="primary"
                    :disabled="
                      disableAction ||
                        isSoldOut ||
                        isDisabled(selectSKU, 'capacity')
                    "
                    depressed
                    :width="isVip ? 'fit-content' : '160px'"
                    @click="onClickCheckout"
                  >
                    <div class="full-payment-content">
                      <div>
                        {{
                          disableAction ||
                          isSoldOut ||
                          isDisabled(selectSKU, 'capacity')
                            ? 'สินค้าหมด'
                            : isVip
                            ? 'ลงทะเบียนความสนใจ'
                            : 'จองสินค้า'
                        }}
                      </div>
                    </div>
                  </v-btn>
                  <BaseReminder
                    v-if="isSoldOut && !isFromStockCard"
                    ref="reminderRef"
                    :data="selectSKU"
                    @submit="handleReminder"
                  />
                </div>
              </div>
            </div>
          </template>
        </PDPStickyCTA>

        <ModalTerm
          @agree="onAgreeModalTerm"
          @close="modalTerm = false"
          :show="modalTerm"
        />
      </div>
    </template>
    <template v-else>
      <v-container>
        <v-row>
          <v-col md="6" sm="12">
            <v-skeleton-loader
              v-bind="attrs"
              type="image"
            ></v-skeleton-loader>
          </v-col>
          <v-col md="6" sm="12">
            <v-skeleton-loader
              v-bind="attrs"
              type="article"
            ></v-skeleton-loader>

            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>
            <v-skeleton-loader
              v-bind="attrs"
              type="list-item"
            ></v-skeleton-loader>

            <v-skeleton-loader
              v-bind="attrs"
              type="article"
            ></v-skeleton-loader>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
import cartSummary from '@/mixins/cartSummary'
import config from '@/config/index'
import isBnn from '@/config/isBnn'
import branchTypes from '@/config/branchTypes'
import colorBnn from '@/config/color'
import routePage from '@/config/routePage'
const { showFreeBie } = config
import { STOCK_CARD_TYPE } from '@/config/stockCard'
import { PRODUCT_TYPE } from '@/config/product'
import {
  getRegisteredStorageKey,
  getMemberVerifiedStorageKey,
  resizeImage,
} from '@/utils/helpers'
import Load from './Load'
import loadCampaign from '../utils/loadcampaign'
import PreviewImageSwiper from '@/components/bnn/PreviewImageSwiper'
import ModalTerm from '@/components/bnn/ModalTerm'
import CountDown from '@/components/bnn/CountDown'
import AppleCare from '@/components/bnn/AppleCare'

export default {
  mixins: [cartSummary],

  computed: {
    ...mapState({
      modelLoading: state => state.model.isLoading,
      isLoaded: state => state.model.isLoaded,
      campaign: state => state.campaign.current,
      campaignLoading: state => state.campaign.isLoading,

      model: state => state.model.selectModel,
      selectColor: state => state.model.selectColor,
      //   selectSKU: state => state.model.selectSKU,

      //   New Studio7
      selectLevel1: state => state.model.selectGroup,
      selectLevel2: state => state.model.selectColor,
      selectLevel3: state => state.model.selectModel,
      selectSKU: state => state.model.selectSKU,

      productData: state => state.model.products,
      paymentTypeData: state => state.paymentType.data,
      branchType: state => state.branchStore.branchType,
      cartSummaryData: state => state.cart.cartSummaryData,
      isCartLoading: state => state.cart.isLoading,
      additionalProduct: state => state.model.additionalProduct,
    }),

    ...mapGetters({
      cartItems: 'cart/cartItems' ?? [],
      modelItems: 'model/getModels',
      colorItems: 'model/getColors',
      storageItems: 'model/getStorages',
      priceSummary: 'cart/priceSummary',
      bundlesItems: 'model/getBundles',
      soldOut: 'model/getSoldOut',
      appleCare: 'model/getAppleCare',
      warranties: 'model/getWarranties',
      getFreebie: 'model/getFreebie',
      accessoryBundles: 'model/getAccessoryBundles',

      p_level1: 'model/getProductLevel1',
      p_level2: 'model/getProductLevel2',
      p_level3: 'model/getProductLevel3',
      p_level4: 'model/getProductLevel4',

      productFamilies: 'model/getProductFamilies',
    }),

    selectLevel1Code() {
      return this.selectLevel1?.code ?? ''
    },

    selectLevel2Code() {
      return this.selectLevel2?.code ?? ''
    },

    selectLevel3Code() {
      return this.selectLevel3?.code ?? ''
    },

    cartClass() {
      // get position div class cart-ship-wrapper

      return {
        'cart-fixed': this.scrollY > this.positionCartShip,
      }
    },

    isVip() {
      return this.campaign?.data?.is_vip_preview ?? false
    },

    isLoading() {
      return this.campaignLoading || this.modelLoading
    },

    isDeposit() {
      return this.branchType === this.branchTypes.BRANCH_TYPE_DEPOSIT
    },

    isDeliveryHome() {
      return (
        this.campaign?.data?.is_delivery_home &&
        !this.$route.query.code
      )
    },

    isShowBtnDeposit() {
      return this.campaign?.data?.deposit_payment
    },

    isShowBtnFullPayment() {
      return this.campaign?.data?.full_payment
    },

    isShowBtnFullPaymentStaff() {
      if (this.campaign?.data?.staff_payment) {
        return (
          this.paymentTypeData?.filter(i => i.type !== 'deposit')
            ?.length > 0
        )
      }
      return false
    },

    isShowWarrantyProduct() {
      const c = this.campaign?.data || {}
      const hasWarranty = !!(this.appleCare && this.appleCare.active)

      if (!hasWarranty) return false

      if (this.isFromStockCard) return !!c.show_warranty_on_stockcard

      return !!(
        c.show_warranty_on_fullpay_pickup ||
        c.show_warranty_on_fullpay_delivery ||
        c.show_warranty_on_deposit
      )
    },

    activeWarranties() {
      return (this.warranties || []).filter(w => w.active)
    },

    hasMultipleWarranties() {
      return this.activeWarranties.length > 1
    },

    bundlesItemsNoFreebie() {
      const freebieRegex = /free/i

      return this.bundlesItems?.filter(
        i =>
          i?.type !== PRODUCT_TYPE.PROMOTION &&
          !i?.type.match(freebieRegex),
      )
    },

    isShowSwiperBundle() {
      return this.bundlesItemsNoFreebie?.length > 0
    },

    isFromStockCard() {
      return !!this.$route.query.code
    },

    freebieItems() {
      return (
        this.getFreebie?.map(i => {
          return {
            id: i.id,
            sku: i.sku,
            name: i.name,
            image: i.image_url,
            limit: i.limit,
            price: i.price_srp,
          }
        }) ?? []
      )
    },

    isShowLabelFreebie() {
      return (
        this.freebieItems?.length > 0 &&
        this.freebieItems?.filter(i =>
          this.cartItems.find(c => c.sku === i.sku),
        )
      )
    },

    modelName() {
      return this.model?.name
    },

    campaignId() {
      return this.campaign?.data?.id ?? ''
    },

    campaignName() {
      return this.campaign?.data?.name
    },

    stickyBanner() {
      return this.campaign?.data?.sticky_banner
    },

    stickyLink() {
      return this.campaign?.data?.sticky_link
    },

    campaignStatus() {
      return this.campaign?.data?.status
    },

    conditionHtml() {
      return this.selectSKU?.condition_html
    },

    rotateHtml() {
      return (
        this.selectSKU?.html_360 || this.selectSKU?.condition_html
      )
    },

    isShowConditionHtml() {
      if (!this.selectSKU?.condition_html) {
        return false
      }
      return true
    },

    previewHtml() {
      return this.selectSKU?.preview_html
    },

    footerHtml() {
      return this.selectSKU?.footer_html
    },

    compareHtml() {
      return this.selectSKU?.compare_html
    },

    shipDate() {
      return (
        this.selectSKU.shipping_date ||
        this.campaign?.data?.shipdate ||
        'ไม่พบข้อมูล'
      )
    },

    selectColorName() {
      return this.selectColor?.color ?? ''
    },

    selectCapacityName() {
      return this.selectSKU?.size ?? ''
    },

    forceBuyBundle() {
      return this.selectSKU?.force_bundle === 1
    },

    slug() {
      return this.campaign?.data?.slug
    },

    isSoldOut() {
      if (this.soldOut) {
        return this.soldOut
      } else {
        return !this.selectSKU?.active
      }
    },

    sku() {
      return this.selectSKU?.sku
    },

    remainingAmount() {
      return this.priceSummary - this.selectSKU?.price_deposit
    },

    priceDeposit() {
      return this.cartSummaryData?.product_price_deposit_summary ?? 0
    },

    priceFullPayment() {
      // Notes: Previous code is cartSummaryData.final_price
      return this.cartSummaryData?.final_price_original ?? 0
    },

    depositTitle() {
      // TODO: remove
      // if (this.selectSKU?.price_deposit) {
      //   return `มัดจำค่าเครื่อง ฿${numeral(
      //     this.selectSKU?.price_deposit ?? 0,
      //   ).format('0,0')}.-`
      // }
      //   `มัดจำค่าเครื่อง`
      // สั่งซื้อล่วงหน้า แบบมัดจำ
      return 'จองพร้อมมัดจำ'
    },

    thumbnailList() {
      let imageList

      if (!imageList) {
        imageList = this.selectSKU?.images?.map((item, index) => {
          let img = resizeImage(item, 1000)
          return { id: index + 1, imageUrl: img }
        })
      }

      if (!imageList) {
        imageList = this.selectColor?.data?.[0]?.images?.map(
          (item, index) => {
            let img = resizeImage(item, 1000)
            return { id: index + 1, imageUrl: img }
          },
        )
      }

      if (!imageList) {
        imageList = this.model?.model?.map((item, index) => {
          let img = resizeImage(item.data[0].image_url, 1000)
          return { id: index + 1, imageUrl: img }
        })
      }

      return imageList ?? []
    },

    disableAction() {
      return !this.selectSKU
    },

    endDateTime() {
      return this.campaign?.data?.ended_at_timestamp * 1000
    },

    endTime() {
      return moment(
        this.campaign?.data?.ended_at_timestamp * 1000,
      ).format('HH:mm')
    },

    expiredAt() {
      return moment(
        this.campaign?.data?.ended_at_timestamp * 1000,
      ).format('DD MMMM YYYY HH:mm')
    },

    timeLeft() {
      if (this.campaign?.data?.status === 'active') {
        return (
          (this.campaign?.data?.ended_at_timestamp -
            this.campaign?.data?.current_datetime_timestamp) *
            1000 ?? -1
        )
      }
      return -1
    },

    bundleList() {
      if (this.selectSKU) {
        const bundleItem = this?.cartItems
          ?.filter(
            i =>
              i?.type !== PRODUCT_TYPE.PROMOTION &&
              !i?.isFreeBie &&
              !i?.isFreeBieMember &&
              !i?.isPromotion,
          )
          ?.map(item => {
            if (
              item?.type === 'bundle' &&
              item?.sku !== this.appleCare?.sku
            ) {
              return ` ${item?.name} `
            }
          })

          ?.filter(i => i)

        return bundleItem.toString()
      }
      return ''
    },

    titleTextCapacity() {
      return localStorage.getItem('slug')?.indexOf(`watch`) > -1
        ? 'สาย'
        : 'สี'
    },

    hasAdditionalProduct() {
      return this.additionalProduct?.length > 0
    },

    hasAlSoBought() {
      return (
        this.appleCare &&
        this.appleCare?.active &&
        this.accessoryBundles?.length > 0
      )
    },

    isFromQRCode() {
      const { sku, code, t } = this.$route.query
      if (sku && code && t) {
        return true
      }
      return false
    },

    isTabContent() {
      return this.footerHtml ? true : false
    },

    isTabCompare() {
      return this.compareHtml ? true : false
    },

    startDate() {
      return moment(this.campaign?.data?.started_at).format(
        'DD MMMM YYYY',
      )
    },

    metaStartDate() {
      return this.campaign?.data?.started_at
        ? moment(this.campaign?.data?.started_at).format(
            'DD MMMM YYYY เวลา HH:mm น.',
          )
        : ''
    },

    metaProductModel() {
      return this.productData
        ?.map(i => i.name)
        .filter(i => i)
        .join(', ')
        .replace(/, ([^,]*)$/, ' และ $1')
    },

    pdpInfoAccordion() {
      return [
        {
          title: 'การรับประกัน',
          desc: 'การรับประกันหลังการขายที่ศูนย์ iCare สาขาทั่วประเทศ',
        },
      ]
    },

    pdpOverviewAccordion() {
      return [
        {
          title: this.isVip ? 'รายละเอียด' : 'ภาพรวมสินค้า',
          desc: this.previewHtml,
        },
      ]
    },

    hasWarrantyInCart() {
      return this.cartItems.some(item => item?.type === 'warranty')
    },

    buName() {
      return isBnn ? 'BaNANA' : 'Studio7'
    },

    metaTitle() {
      if (this.isVip) {
        return 'ลงทะเบียนสนใจ Member Benefit'
      }

      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} รับสิทธิพิเศษมากมายที่ ${this.buName}`
    },

    metaDescription() {
      if (this.isVip) {
        return 'ลงทะเบียนความสนใจ Member Benefit สำหรับสมาชิก 7Club+'
      }
      return `เปิดจอง ${this.campaign?.data?.name ||
        ''} จองก่อนได้ก่อนที่ ${this.buName} Online เปิดจอง ${this
        .metaProductModel || ''} 
		${this.metaStartDate} สมัคร 7 Club+ รอรับสิทธิ์ได้เลย`
    },
  },

  watch: {
    selectSKU(newVal, oldVal) {
      if (newVal?.sku && newVal?.sku !== oldVal?.sku) {
        // fetch payment options for the product
        this.$store.dispatch(
          'paymentType/fetchProductPaymentOptions',
          {
            campaign: this.$route.params?.slug,
            sku: this.selectSKU?.sku ?? this.$route.query?.sku,
            ...(this.$route.query?.code && {
              code: this.$route.query?.code,
            }),
            ...(this.$route.query?.branch_code && {
              branch_code: this.$route.query?.branch_code,
            }),
          },
        )
      }
    },
  },

  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [{ name: 'description', content: this.metaDescription }],
    }
  },

  components: {
    Load,
    PreviewImageSwiper,
    ModalTerm,
    CountDown,
    AppleCare,
    ModalSevenClubMember: () =>
      import('@/components/bnn/ModalSevenClubMember'),
    BundleSwiper: () => import('@/components/bnn/BundleSwiper'),
    AppleCareSwiper: () => import('@/components/bnn/AppleCareSwiper'),
    TabsProduct: () => import('@/components/bnn/TabsProduct'),
    LabelProduct: () => import('@/components/bnn/LabelProduct'),
    // Base
    BaseProductConfigurations: () =>
      import('@/components/base/product/BaseProductConfigurations'),
    BaseProductColorConfigurations: () =>
      import(
        '@/components/base/product/BaseProductColorConfigurations'
      ),
    BaseProductSeriesConfigurations: () =>
      import(
        '@/components/base/product/BaseProductSeriesConfigurations'
      ),

    // studio7 Style
    PDPProductName: () =>
      import('@/components/studio7/PDPProductName'),
    PDPPricing: () => import('@/components/studio7/PDPPricing'),
    PDPStickyCTA: () => import('@/components/studio7/PDPStickyCTA'),
    PDPGallery: () => import('@/components/studio7/PDPGallery'),
    PDPRiverContent: () =>
      import('@/components/studio7/PDPRiverContent'),

    PDPQuantity: () => import('@/components/studio7/PDPQuantity'),
    PDPAccordion: () => import('@/components/studio7/PDPAccordion'),
    PDPProductAlsoBought: () =>
      import('@/components/studio7/PDPProductAlsoBought'),
    PDPShipping: () => import('@/components/studio7/PDPShipping'),

    PDPModalLearnMore: () =>
      import('@/components/studio7/PDPModalLearnMore'),
    PDPModalCompare: () =>
      import('@/components/studio7/PDPModalCompare'),
    PDPModalPaymentMethod: () =>
      import('@/components/studio7/PDPModalPaymentMethod'),
    PDPModalPromotionPrivileges: () =>
      import('@/components/studio7/PDPModalPromotionPrivileges'),

    PDPProductFamilies: () =>
      import('@/components/studio7/PDPProductFamilies'),

    BaseReminder: () => import('@/components/base/BaseReminder'),
  },

  data() {
    return {
      branchTypes,
      keyPreview: 0,
      colorBnn,
      isBnn,
      modalTerm: false,
      showFreeBie,
      scrollY,
      positionCartShip: 0,
      attrs: {
        width: '100%',
      },
    }
  },

  provide() {
    return {
      isVip: () => this.isVip ?? false,
    }
  },

  async mounted() {
    await this.refetch()
    this.checkMemberRequestKey()

    if (this.isShowBtnDeposit && !this.isShowBtnFullPayment) {
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_DEPOSIT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
    }

    window.addEventListener('scroll', this.handleScroll)

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  },

  methods: {
    reload() {
      window.location.reload()
    },

    async checkMemberRequestKey() {
      const memberRequestKey = this.$route.query.member_request_key
      if (!memberRequestKey) {
        return
      }

      try {
        // Clear the member state before fetching new data
        localStorage.removeItem(getRegisteredStorageKey(this.slug))
        localStorage.removeItem(
          getMemberVerifiedStorageKey(this.slug),
        )
        this.$refs.sevenClubMemberModal.close()

        await this.$store.dispatch('user/getMemberByKey', {
          clubmember_key: memberRequestKey,
        })

        // Successfully fetched member data, check for errors
        if (this.$store.state.user.member?.isSuccess) {
          this.$route.push({
            query: {
              ...this.$route.query,
              member_request_key: undefined,
            },
          })

          // if history state has 'member_request_key' remove it from the history state
          if (window.history.state && window.history.state.back) {
            // Remove 'member_request_key' from the history state
            const newState = { ...window.history.state }
            delete newState.back.query.member_request_key
            window.history.replaceState(newState, '')
          }

          return
        }

        // If there was an error fetching member data, open the modal
        if (this.$store.state.user.member?.isError) {
          this.$refs.sevenClubMemberModal.open()
          return
        }
      } catch {
        // Handle any unexpected errors
      }
    },

    async refetch() {
      this.$store.commit('cart/resetCouponCode')
      const active = await loadCampaign(this.campaign)

      if (this.campaign?.data?.redirect_url) {
        window.location.href = this.campaign?.data?.redirect_url
      }
      if (active) {
        document.body.style.overflowY = ''
        document.querySelector('html').style.overflowY = ''

        await Promise.all([
          this.$store.dispatch('model/getModel', {
            slug: this.slug,
            reload: true,
          }),
          this.$store.dispatch('model/getStocks', {
            slug: this.slug,
          }),
        ])

        this.$store.dispatch('model/updateStatusSKU')

        // Select follow by query param sku
        const { sku } = this.$route.query
        if (sku) {
          this.findSku(this.modelItems, sku)
        } else {
          this.$store.dispatch('model/autoSelect')
          this.$store.dispatch('model/reset')
          this.$store.dispatch('bundle/reset')
          this.autoSelectForceBundle()
          this.autoSelectFreeBundle()

          this.checkSummary()
        }

        // Set route product latest visit
        localStorage.setItem('productLatestVisit', this.slug)

        await this.$store.dispatch(
          'paymentType/getPaymentType',
          this.campaignId,
        )

        this.$forceUpdate()
      }
    },

    async findSku(data, sku) {
      this.isLoading = true

      this.$store.dispatch('model/autoSelectBySKU', sku)

      this.$store.dispatch('model/updateStatusSKU')
      this.$store.dispatch('bundle/reset')
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()

      this.isLoading = false

      // BNN

      //   this.isLoading = true

      //   for (let i in data) {
      //     for (let j in data[i]?.model) {
      //       for (let k in data[i]?.model[j]?.data) {
      //         if (data[i]?.model[j]?.data[k]?.sku === sku) {
      //           this.$store.dispatch('model/selectModel', data[i])
      //           this.$store.dispatch(
      //             'model/selectColor',
      //             data[i]?.model[j],
      //           )
      //           this.$store.dispatch(
      //             'model/selectSKU',
      //             data[i]?.model[j]?.data[k],
      //           )
      //           this.$store.dispatch('bundle/reset')
      //           this.autoSelectForceBundle()
      //           this.autoSelectFreeBundle()
      //           this.checkSummary()
      //         }
      //       }
      //     }
      //   }

      //   this.isLoading = false

      //   if (!this.selectSKU) {
      //     this.autoSelectSKU('select_model', this.modelItems?.[0])
      //   }
    },

    async onClickLevel1(item) {
      if (item.main_sku) {
        this.findSku(this.modelItems, item.main_sku)
        return
      }

      this.keyPreview++
      await this.$store.dispatch('model/selectLevel1', item)
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    async onClickLevel2(item) {
      this.keyPreview++
      await this.$store.dispatch('model/selectLevel2', item)
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    async onClickLevel3(item) {
      this.keyPreview++
      await this.$store.dispatch('model/selectLevel3', item)
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    async onClickLevel4(item) {
      this.keyPreview++
      await this.$store.dispatch('model/selectLevel4', item)
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    onClickModel(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectModel', item)
      this.autoSelectSKU('select_model', item)
    },

    onClickColor(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectColor', item)
      this.autoSelectSKU('select_color', item)
    },

    onClickCapacity(item) {
      this.keyPreview++
      this.$store.dispatch('model/selectSKU', item)
      this.$store.dispatch('bundle/reset')
      this.autoSelectForceBundle()
      this.autoSelectFreeBundle()
      this.checkSummary()
      this.$forceUpdate()
    },

    onClickSelectBundle(item) {
      if (!this.forceBuyBundle) {
        this.$store.dispatch('bundle/toggle', item)
      }
      this.$forceUpdate()
      this.checkSummary()
    },

    onClickFull() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_FULL_PAYMENT,
      )
      if (this.isDeliveryHome) {
        this.$store.dispatch('cart/setDelivery', 'delivery')
      } else {
        this.$store.dispatch('cart/setDelivery', 'store')
      }

      const isStockCardOffline =
        this.$route.query?.t &&
        this.$route.query?.t !== STOCK_CARD_TYPE.QR_ONLINE

      let id = isStockCardOffline
        ? this.paymentTypeData?.filter(
            i => i.type === 'pay-at-store',
          )?.[0]?.id
        : this.paymentTypeData?.filter(i => i.type !== 'deposit')?.[0]
            ?.id

      this.$store.commit('paymentType/setPaymentId', id)
      this.checkSummary()
    },

    onClickFullStaff() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_FULL_PAYMENT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
      this.$store.commit(
        'paymentType/setPaymentId',
        this.paymentTypeData?.filter(i => i.type !== 'deposit')?.[0]
          ?.id,
      )
      this.checkSummary()
    },

    onClickDeposit() {
      this.modalTerm = true
      this.$store.commit(
        'branchStore/setBranchType',
        branchTypes.BRANCH_TYPE_DEPOSIT,
      )
      this.$store.dispatch('cart/setDelivery', 'store')
      this.$store.commit(
        'paymentType/setPaymentId',
        this.paymentTypeData?.filter(i => i.type === 'deposit')?.[0]
          ?.id,
      )
      this.checkSummary()
    },

    onAgreeModalTerm() {
      this.modalTerm = false
      if (this.hasAdditionalProduct) {
        this.$router
          .push({
            name:
              routePage?.[process.env.VUE_APP_CAMPAIGN_TYPE]?.[
                this.branchType
              ]?.[this.$route.name]?.nextPage,
            params: { slug: this.slug },
          })
          .catch(() => true)
      } else {
        this.$router
          .push({
            name: 'Cart',
            params: {
              slug: this.slug,
            },
          })
          .catch(() => true)
      }
    },

    // ? New: GP-230 [NPI] Display only one button for both deposit and full payment, with the user selecting the payment type (deposit or full) on the checkout page instead of the PDP
    onClickCheckout() {
      this.$router
        .push({
          name: 'Cart',
          params: {
            slug: this.slug,
          },
        })
        .catch(() => true)
    },

    autoSelectForceBundle() {
      if (this.forceBuyBundle) {
        this.bundlesItems.forEach(item => {
          if (item.active) this.$store.dispatch('bundle/toggle', item)
        })

        // if (this.appleCare.active) {
        //   this.$store.dispatch('bundle/toggle', this.appleCare)
        // }
      }
    },

    autoSelectFreeBundle() {
      this.bundlesItems?.forEach(item => {
        if (item.type === PRODUCT_TYPE.FREE && item.active)
          this.$store.dispatch('bundle/toggle', item)
      })
      this.warranties?.forEach(w => {
        if (w.type === PRODUCT_TYPE.FREE && w.active)
          this.$store.dispatch('bundle/toggle', w)
      })
    },

    autoSelectSKU(
      type = 'select_model',
      selectItem = this.modelItems?.[0],
    ) {
      if (type === 'select_model') {
        let indexColor = 0
        let indexSKU = 0

        if (this.isDisabled(selectItem, 'model')) {
          for (const i in this?.modelItems) {
            if (!this.isDisabled(this?.modelItems?.[i], 'model')) {
              selectItem = this?.modelItems?.[i]
              this.$store.dispatch('model/selectModel', selectItem)
              break
            }
          }
        }

        for (const i in selectItem?.model) {
          if (!this.isDisabled(selectItem?.model?.[i], 'color')) {
            // ? Note: Ignore disabled
            // if (selectItem?.model?.[i]) {
            indexColor = i
            break
          }
        }
        for (const i in selectItem?.model?.[indexColor]?.data) {
          if (
            !this.isDisabled(
              selectItem?.model?.[indexColor]?.data?.[i],
              'capacity',
            )
          ) {
            // ? Note: Ignore disabled
            //   if (selectItem?.model?.[indexColor]?.data?.[i]) {
            indexSKU = i
            break
          }
        }

        this.$store.dispatch(
          'model/selectColor',
          selectItem?.model?.[indexColor],
        )
        this.onClickCapacity(
          selectItem?.model?.[indexColor]?.data?.[indexSKU],
        )
      } else if (type === 'select_color') {
        let indexSKU = 0
        for (const i in selectItem?.data) {
          if (!this.isDisabled(selectItem?.data?.[i], 'capacity')) {
            // ? Note: Ignore disabled
            //   if (selectItem?.data?.[i]) {
            indexSKU = i
            break
          }
        }
        this.onClickCapacity(selectItem?.data?.[indexSKU])
      }
    },

    isDisabled(item, type = 'model') {
      // TODO: check nesting stock
      // old code return false && item
      let active = false

      const { sku } = this.$route.query

      if (this.isFromQRCode) {
        if (item === this.selectSKU) {
          return false
        } else if (type === 'model') {
          for (const models of item?.model) {
            for (const model of models?.data) {
              if (model?.active && model?.sku === sku) {
                active = true
                break
              }
            }
          }
          return !active
        } else if (type === 'color') {
          item?.data?.forEach(i => {
            if (i?.active && i?.sku === sku) {
              active = true
            }
          })
          return !active
        }
        return true
      } else {
        if (type === 'model') {
          for (const models of item?.model) {
            for (const sku of models?.data) {
              if (sku?.active) {
                active = true
                break
              }
            }
          }
          return !active
        } else if (type === 'color') {
          item?.data?.forEach(i => {
            if (i?.active) {
              active = true
            }
          })
          return !active
        } else if (type === 'capacity') {
          return !item?.active
        }
      }
    },

    handleScroll() {
      const checkoutActionHeight = document.querySelector(
        '.cart-ship-wrapper',
      )?.offsetHeight
      this.scrollY =
        window.scrollY + window.innerHeight - checkoutActionHeight
      // this.scrollY = window.scrollY
      this.positionCartShip = this.$refs.cartShip?.offsetTop
    },

    handleOpenLearnMore() {
      this.$refs.PDPModalLearnMore.openModal()
    },

    handleOpenCompare() {
      this.$refs.PDPModalCompare.openModal()
    },

    async handleOpenPaymentMethod() {
      await this.$store.dispatch(
        'staticPage/getStaticPage',
        'installment-plan-modal',
      )

      this.$refs.PDPModalPaymentMethod.openModal()
    },

    async handleOpenPromotionPrivileges() {
      await this.$store.dispatch(
        'staticPage/getStaticPage',
        'promotion-and-privileges-modal',
      )

      this.$refs.PDPModalPromotionPrivileges.openModal()
    },

    async handleReminder(event) {
      try {
        await this.$store.dispatch('reminder/reminderRequest', event)

        if (this.$store.getters['reminder/isSuccess']('submit')) {
          this.$refs.reminderRef.close()
        }
      } catch {
        // Do nothing
      }
    },

    isCannotContinueWithWarranty(type) {
      const c = this.campaign?.data || {}
      let canContinue = false

      if (this.isFromStockCard) {
        canContinue = !!c.show_warranty_on_stockcard
      } else {
        if (type === 'full-payment') {
          canContinue = !!(
            c.show_warranty_on_fullpay_delivery ||
            c.show_warranty_on_fullpay_pickup
          )
        } else {
          canContinue = !!c.show_warranty_on_deposit
        }
      }

      return !canContinue && this.hasWarrantyInCart
    },
  },
}
</script>

<style lang="stylus" scoped>
.product-detail {
  margin-top: 150px;
  @media small {
    margin-top: 200px;
  }
}

.color-content {
  display: grid;
  gap: 16px 4px;
  grid-template-columns: repeat(8, 1fr);

  @media small {
   display: flex;
   justify-content: flex-start;
   flex-wrap: wrap !important;
   background: white;
   padding: 0
   gap 24px
  }
}

.capacity-content {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(1, 1fr);

  @media screen and (max-width: 768px) {
     grid-template-columns: repeat(1, 1fr);
  }
}

.condition {
    display: block;
    overflow: hidden;
    border-radius: 8px
    background: $color-bnn-gray-light-2
    padding: 0.75rem 1rem
    @media small {
      overflow: scroll;
      max-height: 120px
    }
}

.text-label {
  font-weight: bold
}

.price-summary {
  color:  $color-text-price
  color:  $color-bnn
  font-weight: bold
  font-size: 1rem
  text-align: right
}

.price-summary-deposit {
  color:  $color-bnn
  font-weight: bold
  font-size: 1rem
  text-align: right
}

.text-bnn-red-2 {
  color: $color-bnn-red-2
}

.text-ship-date {
    color: $color-bnn-blue-2
    font-weight: bold
}

.gallery {
    display: flex
    justify-content: center
    flex-direction: column
    justify-content: flex-start
    @media screen and (max-width: 767) {
      padding: 0
      display: flex
      justify-content: center
      width: 100%
    }
}

.harry-up
    color: $color-text-harry-up

.preview-html
  overflow: hidden

@media screen and (max-width: 768px)
  .gallery
    padding 0

.button-to-cart-action
    margin-left: -12x !important
    margin-right: -12px !important


.wrap-btn-action
  display: flex
  flex-wrap: wrap
  gap: 0.75rem

.wrap-btn-action-case
  width: 100%
  display: flex
  align-items: center
  justify-content: flex-end
  flex-wrap: wrap
  gap: 0.75rem
  @media screen and (min-width: 768px)
    flex-wrap: nowrap;
    gap: 1rem
  .btn-action-item
    flex-basis: 100%;
    @media screen and (min-width: 768px)
      flex-basis: 50%;
      &.full
        flex-basis: 100%;

@media screen and (max-width: 960px)
  .footer-margin
    margin-bottom: 150px;


.product-detail-layout
  display: flex
  justify-content: center
  flex-direction: column
  padding-top: 22px
  .pdp-preview-swiper
    width: 100%
    @media screen and (min-width: 48rem)
      width: 50%
    @media screen and (min-width: 61.875rem)
      padding-top: 0
      width: 63.5%
  .pdp-content
    width: 100%
    @media screen and (min-width: 768px)
        padding: 12px
        padding-left: 48px
        padding-right: 0px
    @media screen and (min-width: 48rem)
      width: 50%
    @media screen and (min-width: 61.875rem)
        width: 36.5%
        padding-left: 48px
  @media screen and (min-width: 48rem)
    flex-direction: row

.-is-bnn
	.product-detail-layout
		.pdp-preview-swiper
			@media screen and (min-width: 48rem)
				width: 50%
			@media screen and (min-width: 61.875rem)
				width: 50%
		.pdp-content
			@media screen and (min-width: 48rem)
				width: 50%
			@media screen and (min-width: 61.875rem)
				width: 50%

.btn-deposit {
    padding: 0.75rem !important
    font-weight: bold !important
    font-size: 0.875rem !important
    background: $color-deposit !important

    &.disabled {
      pointer-events: none;
      cursor: not-allowed;
      opacity: 0.5
    }

}

.full
  .btn-deposit
    background: $color-bnn !important
    .text-deposit
      color: $color-bnn-btn-text !important
      font-size: 1rem !important
  .full-payment-content
    font-size: 1rem !important


.btn-bnn-default
  padding: 0.75rem !important

.text-deposit
    color: $color-deposit-text

.deposit-content,.full-payment-content
  width: 100%
  display: flex
  justify-content: center
  gap: 8px
  align-items: baseline;
  white-space: nowrap

.product-label-layout
  display: flex
  flex-wrap: auto

.action-contain-layout
  display flex
  width: 100%
  flex-direction: row
  justify-content: space-between
  flex-wrap: wrap
  padding: 0.5rem 0 2px 0
  .soldOut
    width: 100%
    padding: 12PX
  .deposit
    width: 50%
    padding: 12PX
    @media screen and (max-width: 960px)
      width: 100%
    @media small
      padding 4px 12px
  .full
    width: 50%
    padding: 12PX
    @media screen and (max-width: 960px)
      width: 100%
    @media small
      padding 4px 12px
  .full-employee
    width: 100%
    padding: 12PX
    cursor: pointer
    .text-employee
      font-weight: bold
    .text-payment
      margin-left: 0px
      font-weight: bold
      color: $color-bnn
  @media screen and (max-width: 960px)
    flex-direction: row
    align-items: center

.w-full
  width: 100% !important

.ship-date-summary-price-layout
  display flex
  justify-content: space-between
  width: 100%
  @media tablet
    flex-direction: row
    align-items: flex-start
    justify-content: space-between
    text-align: center
  align-items: flex-start
  .ship
    max-width: 100%
    color: $color-bnn-border-dark-btn
    .ship-date
      font-weight: bold
      color: $color-bnn-border-dark-btn
    @media tablet
      width: 100%

  .price
    color: $color-bnn-border-dark-btn
    @media tablet
      text-align: right
      padding: 0.5rem 0
      width: 100%

.desktop-only
  display: block
  @media tablet
    display: none

.html-content
  overflow: auto
  width: 100%
  min-width: 100%
  justify-content: center;

.hurry-up-label
  display: block

.campaign-name-content {
  @media small {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding 1rem 0;
  }
}

.cart-fixed {
  //@media small {
    position: fixed
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    z-index: 50
    width: 100%
    bottom: 0
    left:0
    padding: 1rem


    background: #f2f2f2
    box-shadow: 1px 1px 2px 1px $color-gray-200;
  //}
}

.ship-date-row {
  margin-top: 0
}

.color-wrapper{
  width: 100%

  @media small {

  }
}

.capacity-wrapper {
  width: 100%

  @media small {
  }
}

.is-mobile {
  display: none
  @media screen and (max-width: 600px) {
    display: block
  }
}

.is-desktop {
  display: block
  @media screen and (max-width: 600px) {
    display: none
  }
}

.title-also-bought {
  padding-top: 1rem
  font-weight: bold
  font-size: 1.25rem
}

.select-by-sku
  .btn-model.disabled
    color: $color-bnn-gray-medium-2
  .btn-model.disabled,
  .btn-color.disabled,
  .btn-spec.disabled
    event-pointer: none
    cursor: not-allowed

.v-btn--disabled.v-btn--outlined
  opacity 0.45
  border-color: rgba(0, 0, 0, 0.26) !important
  .text-deposit
    color: $color-bnn !important

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined).btn-bnn-default
  opacity 0.45
  background-color: $color-bnn !important
  color: $color-bnn-btn-text !important


.pdp-content-container{
    display: flex;
    flex-direction: column;
    gap: 48px;
    max-width: 100dvw;
}

.-is-bnn
  .pdp-content-container{
	gap: 24px;
  }

.badge-pre-order {
    color: #336e7b;
    font-weight: 600
}

::v-deep .v-btn.btn-link.promotion-privileges {
    padding 0 !important
}
</style>
